import { Button } from '@/components/ui/button'
import { translate } from '@/lib/i18n'

const FALLBACK = {
  'crash.title': 'Something went wrong',
  'crash.text': 'Please reload the page and try again.',
  'crash.reload': 'Reload the page',
}

// The crash can happen before any page has loaded its translations.
function text(key) {
  const value = translate(key)
  return value === key ? FALLBACK[key] : value
}

export function CrashScreen() {
  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-4">
      <div className="max-w-sm text-center flex flex-col items-center gap-4">
        <h1 className="text-xl font-semibold">{text('crash.title')}</h1>
        <p className="text-muted-foreground">{text('crash.text')}</p>
        <Button onClick={() => window.location.reload()}>{text('crash.reload')}</Button>
      </div>
    </div>
  )
}
